import { createApp } from 'vue'
import './assets/style/index.less'
import App from './App.vue'
import gameUtils from 'awesome-game-utils'
gameUtils.rem(document, window, 750);
gameUtils.stopZoom();
createApp(App).mount('#app')
